import PropTypes from 'prop-types';
import { Brand, FlexContainer } from '@taxdown/piccolo-web';
import { StyledContainer } from './styles';

const AuthContainer = ({ children, className }) => (
  <StyledContainer direction="column" gap="dimension_24" className={className}>
    <FlexContainer justify="center" align="center">
      <Brand mode="fullDark" withText={false} />
    </FlexContainer>
    {children}
  </StyledContainer>
);

AuthContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

AuthContainer.defaultProps = {
  className: null,
};

export default AuthContainer;
